import { computed } from 'vue';

import { OrderSideEnum } from '@libs/api-reference';

import { useLiveOptionPositionsQuery } from '../index';

export default function useOptionPositionQuery({
  isin,
}: {
  isin: string | null;
  orderSide?: OrderSideEnum;
}) {
  const { optionPositions } = useLiveOptionPositionsQuery();

  const position = computed(() =>
    optionPositions.value.find((e) => e.isin === isin)
  );

  const quantity = computed(() => position?.value?.quantity ?? 0);
  const positionSide = computed(() => position?.value?.positionSide ?? 0);

  return {
    quantity,
    positionSide,
  };
}
